import { aTrack } from '../primitives/a-track';
let appStatusDisplayed = false;
class WalletEvents {
    constructor() {
        this.options = {
            origin: 'wallet',
        };
    }
    clicked_connect_wallet(available_providers) {
        aTrack('clicked_connect_wallet', Object.assign({ available_providers }, this.options));
    }
    opened_terms_of_service() {
        aTrack('opened_terms_of_service', Object.assign({}, this.options));
    }
    opened_privacy_policy() {
        aTrack('opened_privacy_policy', Object.assign({}, this.options));
    }
    selected_wallet_provider(provider) {
        aTrack('selected_wallet_provider', Object.assign({ provider }, this.options));
    }
    wallet_connection_attempt(provider, network) {
        aTrack('wallet_connection_attempt', Object.assign({ provider, network }, this.options));
    }
    wallet_connected(provider, network) {
        aTrack('wallet_connected', Object.assign({ provider, network }, this.options));
    }
    network_warning_displayed(provider, network) {
        aTrack('network_warning_displayed', Object.assign({ provider, network }, this.options));
    }
    network_warning_clicked(provider, network) {
        aTrack('network_warning_clicked', Object.assign({ provider, network }, this.options));
    }
    network_warning_removed(provider) {
        aTrack('network_warning_removed', Object.assign({ provider }, this.options));
    }
    opened_account_information() {
        aTrack('opened_account_information', Object.assign({}, this.options));
    }
    clicked_disconnect_wallet(provider, network) {
        aTrack('clicked_disconnect_wallet', Object.assign({ provider, network }, this.options));
    }
    app_status_popup_displayed(provider, network, reason) {
        if (!appStatusDisplayed) {
            aTrack('app_status_popup_displayed', Object.assign({ provider,
                network,
                reason }, this.options));
        }
        // NOT_OK_HEARTBEAT is 1 minute
        setTimeout(() => (appStatusDisplayed = true), 3000);
    }
    app_status_popup_removed(provider, network, reason) {
        if (appStatusDisplayed) {
            aTrack('app_status_popup_removed', Object.assign({ provider,
                network,
                reason }, this.options));
        }
        // NOT_OK_HEARTBEAT is 1 minute
        setTimeout(() => (appStatusDisplayed = false), 3000);
    }
}
export function createWalletEvent() {
    return new WalletEvents();
}
//# sourceMappingURL=wallet-events.js.map